const ls = require("local-storage");
import funcoesUsuarioService from "../services/funcoesUsuarioService";
import Swal from "sweetalert2";

class funcaoUtilitarios {
  async init(forcarUpdate) {
    try {

      // Obtém os dados do usuário salvos no localStorage
      const nivel_user = ls.get("nivel_user");
      const pkUsuario = ls.get("pkUsuario");
      const i_id = ls.get("i_id");
      const funcoesSavedPed = JSON.parse(ls.get("funcoesSavedPed"));
  
      // Se forçar atualização ou não houver permissões salvas, busca do servidor
      if (forcarUpdate || !funcoesSavedPed || !funcoesSavedPed.length) {

        console.log('entrou funcao');
        
        const response = await funcoesUsuarioService.getFuncoes(
          nivel_user,
          pkUsuario,
          i_id
        );
  
        if (response === 500) {
          Swal.fire(
            "Erro",
            "Erro ao carregar as permissões do usuário!",
            "error"
          );
        } else if (response) {
          // Salva as permissões no localStorage
          ls.set("funcoesSavedPed", JSON.stringify(response));
        } else {
         // Swal.fire("Aviso", "Usuário sem permissões disponíveis!", "info");
        }
      }
    } catch (error) {
      Swal.fire("Erro", "Erro ao inicializar permissões do usuário!", "error");
    }
  }

  verificarFuncaoPed(idFuncaoPed) {
    try {
      // Obtém as permissões salvas ou um array vazio
      const funcoesSavedPed = JSON.parse(ls.get("funcoesSavedPed")) || [];

      // Verifica se a função existe na lista
      return funcoesSavedPed.some((f) => f.idFuncaoPed == idFuncaoPed);
    } catch (error) {
      Swal.fire("Erro", "Erro ao verificar as permissões do usuário!", "error");
      return false;
    }
  }
}

export default new funcaoUtilitarios();
